<script>
    import { nanoid } from "nanoid"

    import FormRow from "../../../components/FormRow.svelte";
    import FormColumn from "../../../components/FormColumn.svelte";
    import Checkbox from "../../../components/Checkbox.svelte";
    import TextDisplay from "../../../components/TextDisplay.svelte";
    import DatePicker from "../../../components/DatePicker.svelte";
    import AddButton from "../../../components/buttons/AddButton.svelte";
    import DeleteButton from "../../../components/buttons/DeleteButton.svelte";

    export let label;
    export let selected;
    export let dates = [];
    export let disabled = null;

    const handleAddDate = () => {
        dates = [...dates, { date: null, id: 0 }];
    };

    const handleDeleteDate = (index) => {
        dates.splice(index, 1);
        dates = [...dates];
    };

    const handleSelectedChange = (e) => {
        if (e.target.checked) {
            dates = [ { date: null, id: 0 } ];
        } else {
            dates = [];
        }
    };

    dates = dates || [];
</script>

<FormRow class="mt-2">
    <FormColumn cols="6" style="margin-top: 14px;">
        <Checkbox {disabled}
            id={nanoid(6)}
            {label}
            bind:checked={selected}
            on:change={handleSelectedChange} />
    </FormColumn>
    <FormColumn cols="4">
        {#if selected}
            {#each dates as date, index}
                <div class="mt-2 delete-box">
                    {#if !disabled}
                        <DatePicker
                            required={index == 0}
                            disabled={disabled}
                            id={nanoid(6)}
                            validator={true}
                            start={new Date(1924, 0, 1)}
                            end={new Date()}
                            placeholder="e.g. 01/05/1987"
                            bind:formattedSelected={date.date}
                            openOnClass="calendar-icon" />
                            {#if dates.length > 1}
                                <span class="delete">
                                    <DeleteButton on:delete={() => handleDeleteDate(index)} title="Delete date"></DeleteButton>
                                </span>
                            {/if}
                    {:else}
                        <TextDisplay
                            value={date.date}
                        />
                    {/if}
                </div>
            {/each}
        {/if}
    </FormColumn>
    <FormColumn cols="2" style="margin-top: 24px" class="align-items-end">
        {#if selected && !disabled}
            <AddButton on:add={() => handleAddDate()} title="Add surgery date">Add</AddButton>
        {/if}
    </FormColumn>
</FormRow>

<style>

    .delete-box {
        position: relative;
        padding-right: 50px;
    }

    .delete {
        position: absolute;
        top: -2px;
        right: 10px;
    }
/* 
    @media (min-width: 768px) {

        .delete {
            right: -40px;
        }

    }
 */
</style>